// extracted by mini-css-extract-plugin
module.exports = {"photoPickerButton":"PhotoPicker__photoPickerButton___2XdVn","photoPlaceholder":"PhotoPicker__photoPlaceholder___2JXO4","photoPlaceholderIcon":"PhotoPicker__photoPlaceholderIcon___3Et71"};


// WEBPACK FOOTER //
// webpack://aws_amplify_ui/src/PhotoPicker.css?07be